

import React, { useEffect, useState } from 'react';
import axios from "axios";
import { toast } from 'react-toastify';
import { Plus } from 'lucide-react';
import CampaignListTable from './CampaignListTable';
import CreateCampaignModal from './CreateCampaignModal';
import { baseURL } from '../../../../Services/api/baseURL';
import ConfirmModal from '../../../ConfirmModal/ConfirmModal';
import useRbac from '../../../../Hooks/useRbac';

const BoostCampaignManager = () => {
  const { can } = useRbac();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [editCampaign, setEditCampaign] = useState(null);
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign,setSelectedCampaign] = useState(null)
  const [isOpen,setIsOpen] = useState(false)

  const [page,setPage] = useState(1)
  const [limit] = useState(10)
  const [totalPages,setTotalPages] = useState(1)


  const getToken = () => JSON.parse(localStorage.getItem("token"));

  // ✅ Fetch campaigns inside component
  const fetchBoostData = async () => {
    try {
      setLoading(true);

      const token = getToken();

      const response = await axios.get(
        `${baseURL}/api/admin/get-all-boost?page=${page}&limit=${limit}`,
        {
          headers: { Authorization: `${token}` }
        }
      );
console.log(response.data,"[[[[[[[[[[[[[[[[[[[[[[")
      setCampaigns(response.data.data?.boostData || response.data);
      setTotalPages(response.data.data?.totalPages||1)

    } catch (error) {
      console.error(error);
      toast.error("Error fetching campaigns");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBoostData();
  }, [page]);

  // ✅ Create campaign inside component
  const handleCreateCampaign = async (newCampaign) => {
    try {
      const token = getToken();

      const response = await axios.post(
        `${baseURL}/api/admin/add-boost`,
        newCampaign,
        {
          headers: { Authorization: `${token}` }
        }
      );

      const createdCampaign = {
        ...response.data?.data,
        analytics: { totalOrders: 0, totalPointsAwarded: 0, revenue: 0 }
      };

      setCampaigns(prev => [...prev, createdCampaign]);
      setShowModal(false);

    } catch (error) {
      console.error(error);
      toast.error("Failed to create campaign");
    }
  };

  // ✅ Toggle status inside component
const handleToggleStatus = async (campaignId, currentStatus) => {
  try {
    const token = JSON.parse(localStorage.getItem("token"));

    let newStatus;
      

    switch (currentStatus) {
      case 'draft':
        newStatus = 'active'; // Draft → Active
        break;
      case 'active':
        newStatus = 'paused'; // Active → Paused
        break;
      case 'paused':
        newStatus = 'active'; // Paused → Active
        break;
      case 'ended':
        toast.error("Ended campaigns cannot be changed");
        return;
      default:
        toast.error("Invalid campaign status");
        return;
    }

    const response = await axios.patch(
      `${baseURL}/api/admin/update-boost-status/${campaignId}`,
      { status: newStatus },
      {
        headers: { Authorization: `${token}` }
      }
    );

    const updatedCampaign = response.data.data;

    setCampaigns(prev =>
      prev.map(c => (c._id === campaignId ? updatedCampaign : c))
    );

    toast.success(`Status changed to ${newStatus}`);

  } catch (error) {
    console.error("Toggle status error:", error);
    toast.error("Error updating campaign status");
  }
};

const handleDeleteModal =(id)=>{
  setSelectedCampaign(id)
  setIsOpen(true)
}

  const handleDelete = async () => {
    // if (!window.confirm("Delete this campaign?")) return;
    

    try {
      const token = getToken();

      await axios.delete(
        `${baseURL}/api/admin/delete-boost/${selectedCampaign}`,
        { headers: { Authorization: `${token}` } }
      );

      setCampaigns(prev => prev.filter(c => c._id !== selectedCampaign));
      setIsOpen(false)
      toast.success("Campaign deleted!");

    } catch (err) {
      console.error(err);
      toast.error("Error deleting campaign");
    }
  };
const handleUpdateCampaign = async (id, updatedData) => {
  try {
    const token = getToken();

    const response = await axios.put(
      `${baseURL}/api/admin/update-boost/${id}`,
      updatedData,
      {
        headers: { Authorization: `${token}` }
      }
    );

    const updated = response.data.data;

    setCampaigns(prev =>
      prev.map(c => (c._id === id ? updated : c))
    );

    toast.success("Campaign updated successfully");
    setShowModal(false);
    setEditCampaign(null);

  } catch (error) {
    console.error(error);
    toast.error("Failed to update campaign");
  }
};

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        
        <div className="flex justify-between items-center mb-6">
          {/* <h1 className="text-3xl font-bold text-gray-900">Boost Campaigns</h1> */}
          <h5 className="fw-bolder">Boost Campaigns</h5>
          {can('boost.create') && <button
            onClick={() => setShowModal(true)}
            className="flex items-center gap-2 bg-[#d3178a] text-white px-4 py-2 rounded-lg hover:bg-[#C4378E] transition"
          >
            <Plus size={20} /> Create Campaign
          </button>}
        </div>

        {loading ? (
          <p className="text-[#d3178a] text-center py-10">Loading...</p>
        ) :campaigns.length===0?(<p>No campaigns found</p>) : (
          <CampaignListTable
          page={page}
          setPage={setPage}
          totalPages={totalPages}
            campaigns={campaigns}
            onToggleStatus={handleToggleStatus}
            onDelete={handleDeleteModal}
            setEditCampaign={setEditCampaign}
            setShowModal={setShowModal}
          />
        )}

{showModal && (
  <CreateCampaignModal
    onClose={() => {
      setShowModal(false);
      setEditCampaign(null);
    }}
    onCreate={handleCreateCampaign}
    editData={editCampaign}     // ✅ send campaign for edit
    onUpdate={handleUpdateCampaign} // ✅ send update handler
  />
)}

      </div>
      <ConfirmModal
      isOpen={isOpen}
      onClose={()=>setIsOpen(false)}
      onConfirm={handleDelete}
      title = "Delete campaign"
      description="Are you sure you want to delete this campaign?"
      />
    </div>
  );
};

export default BoostCampaignManager;
